import { useContext } from 'react';
import { PlusIcon } from '..';

import { UserContext } from '../../../Provider';
import AGButton from '../../../components/Button';
import { ContactProps } from './contact.props';
import { Div } from './contactModal.styled';
import {API_CONSTANT} from '../../../utils/constant';

const apiDomain = process.env.REACT_APP_API_DOMAIN;

const ServiceContactsModal = ({ setShow, bodyContent, data, dataService }: ContactProps) => {
    const user = useContext(UserContext);

    if (dataService === undefined) {
        return null;
    }

    return (
        <>
            {dataService.individuals && dataService.individuals.length ?
                <Div className="contact-contents" >
                    {
                        dataService!.individuals !== undefined ? dataService!.individuals?.sort((a, b) => {
                            const firstNameCompare = a.firstName!.localeCompare(b.firstName!);
                            if (firstNameCompare !== 0) return firstNameCompare;
                            return a.lastName!.localeCompare(b.lastName!);
                        })
                        .map(x => (
                            <div className="firm-idv-contact" key={x.id}>
                                <div className='contact-img'>
                                    {x.avatar && typeof x.avatar === 'string' && x.avatar.trim() !== '' ? (
                                        <img src={x.avatar} alt="avatar" className="ava" />
                                    ) : data?.logoPart ? (
                                        <img
                                            src={data.defaultLogo ? data.logoPart : `${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG}${encodeURIComponent(data.logoPart)}`}
                                            alt=""
                                            className="ava"
                                        />
                                    ) : (
                                        <div className='ava' />
                                    )}
                                </div>
                                <div className='contact-name-service'>
                                    <p>
                                        {
                                            x.firstName + ' ' + x.lastName
                                        }
                                    </p>
                                </div>
                            </div>
                        )) : <></>
                    }
                </Div>
                : user?.firmAddress.firmId === data?.fkFirmId
                    ?
                    <Div className='btn-add-new'>
                        <AGButton
                            type={'Link'}
                            icon={<PlusIcon />}
                            onClick={() => {
                                setShow()
                            }}>
                            {bodyContent}
                        </AGButton>
                    </Div> : <></>
            }
        </>
    )
}

export default ServiceContactsModal;